import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  FilterParamsItem,
  GlobalSearchParams,
  useConfigStore,
  useNonPersistentFilterItemsStore,
} from "../store/config";
import { useRegionalSettingsStore } from "@freyr/freyr-react-common";
// import { convertPathToModule } from "../common/utils";

interface AfterHistoryChangeMessage {
  type: "afterHistoryChange";
  data: { pathname: string; moduleName?: string };
}
type PostMessage = AfterHistoryChangeMessage;

interface GlobalLanguageChangeMessage {
  type: "globalLanguageChange";
  data: "en" | "zh" | "jp";
}
interface GlobalFilterChangeMessage {
  type: "globalFilterChange";
  data: FilterParamsItem[];
}
interface GlobalSearchChangeMessage {
  type: "globalSearchChange";
  data: GlobalSearchParams;
}

interface GlobalRegionalAndLanguageChangeMessage {
  type: "globalRegionalAndLanguageChange";
  data: {
    dateFormat?: string;
    timeFormat?: string;
    timeZone?: string;
    language?: string;
  };
}

type ReceiveMessageEvent = {
  data:
    | GlobalLanguageChangeMessage
    | GlobalFilterChangeMessage
    | GlobalRegionalAndLanguageChangeMessage
    | GlobalSearchChangeMessage;
};

export const useUrfPostEvents = () => {
  const location = useLocation();
  const postMessage = (message: PostMessage) => {
    if (window.parent !== window) {
      window.parent.postMessage(
        message,
        `https://${process.env.REACT_APP_STG_DOMAIN}` //"https://app.devscopes.freyafusion.com/"
      );
    }
  };

  useEffect(() => {
    postMessage({
      type: "afterHistoryChange",
      data: {
        pathname: location.pathname,
        moduleName: "",
        // moduleName: convertPathToModule(
        //   location.pathname?.split("/")?.filter((el) => el)?.[0]
        // ),
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
};

export const useUrfReceiveEvents = () => {
  const [updateLanguage] = useConfigStore((state) => [
    // state.language,
    state.updateLanguage,
  ]);
  const receivedLanguageFromPortal = useRef(false);
  const [updateFilter, updateSearch] = useNonPersistentFilterItemsStore(
    (state) => [state.updateFilter, state.updateSearch]
  );

  //Scenes：If the subapplication's route uses asynchronous loading and a request is made during loading.
  //Problem：Relying solely on the iframe's onLoad event may not ensure that the subapplication loads fully.
  //Solution: Put this hook in App.tsx
  const receiveMessage = (event: ReceiveMessageEvent) => {
    // need to use environment variables
    // if (event.origin !== "https://app.devsecops.freyafusion.com") return;
    // console.log('urf event: ',event);
    
    switch (event.data?.type) {
      case "globalLanguageChange": {
        const curLanData = event.data;
        console.log("globalLanguageChange event.data: ", event.data);
        receivedLanguageFromPortal.current = true;
        if (["en", "jp", "zh"].includes(curLanData.data)) {
          updateLanguage(curLanData.data);
        } else {
          updateLanguage("en");
        }
        break;
      }
      case "globalFilterChange": {
        console.log("globalFilterChange event.data: ", event.data);
        //@ts-ignore
        updateFilter(event.data.data);
        break;
      }
      case "globalRegionalAndLanguageChange": {
        console.log("globalRegionalAndLanguageChange event.data: ", event.data);
        const { dateFormat, timeFormat, timeZone } = event.data?.data ?? {};
        useRegionalSettingsStore.getState().updateRegionalSettings({
          dateFormat,
          timeFormat,
          timeZone,
        });
        break;
      }
      case "globalSearchChange": {
        console.log("globalSearchChange event.data: ", event.data);
        updateSearch(event.data.data);
        break;
      }
      default:
        break;
    }
  };
  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
    const timeoutId = setTimeout(() => {
      if (!receivedLanguageFromPortal.current) {
        updateLanguage("en");
      }
    }, 2000);
    return () => {
      window.removeEventListener("message", receiveMessage);
      clearTimeout(timeoutId);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
